import { Icon } from '../icon/icon'
import styles from './link.module.css'
import { useNavigate } from 'react-router-dom'

type LinkKind = 'primary' | 'secondary' | 'tertiary'

type Props = {
    id?: string
    text?: string
    href?: string
    to?: string
    icon?: string
    children?: JSX.Element | JSX.Element[]
    kind?: LinkKind
    className?: string
    dataBsTarget?: string
    dataBsToggle?: string
    onClick?: () => void
}

export const Link = (props: Props) => {
    const { id = 'link', text, href, to, icon, children, kind, className, dataBsTarget, dataBsToggle, onClick } = props
    const navigate = useNavigate()

    const getKindClass = () => {
        switch(kind) {
            case 'primary':
                return styles.linkPrimary
            default:
                return ''
        }
    }

    const renderContent = () => text ? (
        <>
            {icon && <Icon icon={icon} small rightMargin />}
            {text}
        </>
    ) : children

    const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
            e.preventDefault()
            navigate(to!)
        }
    }

    const renderNavLink = () => (
        <a
            id={id}
            href={to}
            onClick={handleNavClick}
            className={`${styles.link} ${styles.clickable} ${getKindClass()} ${className || ''}`}
        >
            {renderContent()}
        </a>
    )

    const renderLink = () => {
        return (
            <a
                id={id}
                href={href}
                className={`${styles.link} ${styles.clickable} ${className}`}
                data-bs-target={dataBsTarget}
                data-bs-toggle={dataBsToggle}
                target="_blank"
                rel="noreferrer"
            >
                {renderContent()}
            </a>
        )
    }

    const renderDiv = () => {
        const clickableClass = !!onClick ? styles.clickable : ''
        return (
            <div
                id={id}
                onClick={onClick}
                className={`${styles.link} ${getKindClass()} ${clickableClass} ${className}`}
                data-bs-target={dataBsTarget}
                data-bs-toggle={dataBsToggle}
            >
                {renderContent()}
            </div>
        )
    }

    return to ? renderNavLink() : href ? renderLink() : renderDiv()
}
